/**
 * A promise that resolves if/once the DOM has loaded.
 * @type {Promise<void>}
 */
export const documentReady = new Promise((resolve) => {
	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		resolve();
		return;
	}

	const loaded = () => {
		resolve();
	};

	document.addEventListener('DOMContentLoaded', loaded, { once: true });
});
